import React from 'react';
import { MastiffOfferButton } from './styles';
import { IconExternalLink } from '@veneer/core';
import { truncate } from '@uma/react-commons/dist/index';

interface MastiffOfferTagProps {
  offerText: string;
  onClick: () => void;
}

const MastiffOfferTag = ({
  offerText,
  onClick
}: MastiffOfferTagProps): React.ReactElement => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <MastiffOfferButton
      appearance="secondary"
      data-testid="mastiff-offer-tag"
      leadingIcon={<IconExternalLink size={18} />}
      onClick={handleClick}
    >
      {truncate(offerText, 35)}
    </MastiffOfferButton>
  );
};

export default MastiffOfferTag;
